import useLanguage from 'hooks/useLanguage';
import useLocalizedData from 'hooks/useLocalizedData';
import ROAMING_FORM_LABELS from './RoamingMainForm.labels';
import { buildCountryOptions } from './RoamingMainForm.utils';

const useRoamingMainForm = (countries, flags, banners, onSubmit) => {
  const language = useLanguage();
  const [labels] = useLocalizedData(ROAMING_FORM_LABELS);
  const isLoading = !countries?.length;
  const countriesOptions = buildCountryOptions(countries, flags, banners);

  const submitHandler = async (values, helpers) => {
    try {
      if (onSubmit) {
        await onSubmit(values, helpers);
      }
    } finally {
      helpers.setSubmitting(false);
    }
  };

  return {
    language,
    labels,
    isLoading,
    countriesOptions,
    submitHandler,
  };
};

export default useRoamingMainForm;
